import React from 'react';
import { ICheckboxGroupProps, ICheckboxGroupOption, IkeyType } from './checkbox-group-types';
import { StyledCheckbox } from './checkbox-group';

interface ICheckboxGroupContentProps extends Pick<ICheckboxGroupProps, 'minItemWidth' | 'maxItemWidth' | 'disabled' | 'groupName' | 'orientation' | 'onRenderItem'> {
    isChecked: boolean;
    itemData: ICheckboxGroupOption;
    onChangeHandler(checked: boolean, key: IkeyType): void;
}

export const CheckboxGroupContent = React.memo((props: ICheckboxGroupContentProps) => {
    const { isChecked, minItemWidth, maxItemWidth, groupName, orientation, itemData, disabled, onChangeHandler, onRenderItem, ...rest } = props;
    const { key, name, title } = itemData;

    const onSingleSelection = React.useCallback(() => {
        onChangeHandler(!isChecked, key);
    }, [onChangeHandler, isChecked, key]);

    if (onRenderItem) {
        return (
            <>
                {onRenderItem({ isSelected: isChecked, isDisabled: disabled!, itemData, toggleSelection: onSingleSelection })}
            </>
        );
    }

    return (
        <StyledCheckbox
            {...rest}
            checked={isChecked}
            label={name}
            name={groupName}
            key={key}
            value={key}
            title={title}
            onValueChange={onChangeHandler}
            $orientation={orientation}
            $minItemWidth={minItemWidth}
            $maxItemWidth={maxItemWidth}
            disabled={disabled} />
    );
});

CheckboxGroupContent.displayName = 'CheckboxGroupContent';
